import acs from '@mos-utils/acs';

const isDev = process.env.NODE_ENV === 'development';
export const isShowError = true; //isDev;
export const isDevAuth = process.env.NODE_ENV === 'development';
export default isDev;

if (isDevAuth) {
  acs.configure({ mock: 'authorized' }); // методы `probe` и `getToken` разрезолвятся со значением `true`
}
